import React from 'react';

class CouponCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coupon:'',
            applied: false
        };
        this.onApplyCoupon = this.onApplyCoupon.bind(this);
        this.onRemoveCoupon = this.onRemoveCoupon.bind(this);
      }

      onApplyCoupon() {
          const {onApplyCoupon} = this.props;
          onApplyCoupon(this.state.coupon);
      }
      onRemoveCoupon () {
        const {onRemoveCoupon, discount} = this.props;
        this.setState({coupon:''})
        onRemoveCoupon(this.state.coupon, discount);
      }

      render () {
          const {discountMessage, discount} = this.props;
          console.log(discountMessage)
          return discount && discount.code?
          (
              <div>
                  <div>PROMO: <span>{discount.code}</span> <button className="cancel" onClick={this.onRemoveCoupon}>x</button></div>
                  <div><span className="text-success">Coupon Applied</span></div>
              </div>
          )
          :
          (
            <div>
                <input className="promo-code-input" value={this.state.coupon} placeholder="PROMO CODE" aria-label="PROMO CODE" onChange={(event) => this.setState({coupon:event.target.value})} />
                <button className="button button-block" onClick={this.onApplyCoupon}>APPLY</button>
                {
                    discountMessage?
                    (<div><span className="text-danger">{discountMessage}</span></div>)
                    :null
                }
            </div>
          )
      }

}

module.exports = CouponCode




// WEBPACK FOOTER //
// ./src/components/commons/coupon/CouponCode.js